import React from 'react';
import { IoDocumentOutline } from 'react-icons/io5';
import { CourseDetailsResponse } from '../../../../interfaces/api/courses';
import FileItem from '../../../../components/fileItem';

interface FilesProps {
  selectedCourse: CourseDetailsResponse;
}

const Files: React.FC<FilesProps> = ({ selectedCourse }) => {
  if (!selectedCourse) {
    return (
      <div className="animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="border rounded-lg overflow-hidden mb-8">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex items-center p-4 border-b last:border-none">
              <div className="w-10 h-10 rounded-full bg-gray-200 mr-4"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-1/3"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const renderExerciseFiles = () => {
    const sectionsWithFiles = selectedCourse?.sections.filter((item) => item.pdfs && item.pdfs.length > 0);

    if (!sectionsWithFiles || sectionsWithFiles.length === 0) {
      return (
        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-8 text-center">
          <div className="w-12 h-12 mx-auto mb-4 rounded-lg bg-primary/10 dark:bg-primary/5 flex items-center justify-center border border-gray-200 dark:border-gray-700">
            <IoDocumentOutline size={24} className="text-primary" />
          </div>
          <h3 className="text-lg font-medium text-gray-600 dark:text-gray-300 mb-2">No Course Materials</h3>
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            This course doesn't have any downloadable materials yet.
          </p>
        </div>
      );
    }

    return (
      <div className="space-y-8">
        {sectionsWithFiles.map((section) => (
          <div key={section.id}>
            <h2 className="text-lg font-bold text-titleText dark:text-gray-100 mb-3">{section.name} - Files</h2>
            <div className="border dark:border-gray-700 rounded-lg overflow-hidden divide-y divide-gray-200 dark:divide-gray-700">
              {section.pdfs?.map((item) => <FileItem key={`file_${item.id}`} name={item.name} url={item.url} />)}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderCertificate = () => {
    const certificateUrl = 'https://example.com/certificate.pdf';

    if (!selectedCourse?.name) {
      return null;
    }

    return (
      <div className="mt-8">
        <h2 className="text-lg font-bold text-titleText dark:text-gray-100 mb-3">Certificate</h2>
        <div className="border dark:border-gray-700 rounded-lg overflow-hidden">
          <FileItem name={`${selectedCourse.name} - Certificate`} url={certificateUrl} />
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderExerciseFiles()}
    </div>
  );
};

export default Files;
